"use strict";
/**
 * Created by fan on 1/13/17.
 */
exports.__esModule = true;
var schema_error_1 = require("./schema-error");
var smartorg;
(function (smartorg) {
    var r6;
    (function (r6) {
        var acts;
        (function (acts) {
            var universal;
            (function (universal) {
                var schema;
                (function (schema) {
                    var logic;
                    (function (logic) {
                        /**
                         * Who can access the schema.
                         */
                        var Access = /** @class */ (function () {
                            /**
                             * Set who can see this schema.
                             *
                             * @param portfolioAdmin {boolean} Portfolio admins should
                             *     always set to true.
                             * @param contributor {boolean}
                             * @param observer {boolean}
                             * @param groups {Array<string>} List of group ids. User in
                             *     these groups can see the schema.
                             * @param users {Array<string>} List of user ids. These users
                             *     can see the schema.
                             */
                            function Access(portfolioAdmin, contributor, cateContributor, observer, groups, users) {
                                this.portfolioAdmin = portfolioAdmin == true;
                                this.contributor = contributor == true;
                                this.cateContributor = cateContributor == true;
                                this.observer = observer == true;
                                this.groups = groups ? groups.slice() : undefined;
                                this.users = users ? users.slice() : undefined;
                            }
                            Access.prototype.getData = function () {
                                return {
                                    'portfolioAdmin': this.portfolioAdmin,
                                    'contributor': this.contributor,
                                    'cateContributor': this.cateContributor,
                                    'observer': this.observer,
                                    'groups': this.groups ? this.groups.slice() : undefined,
                                    'users': this.users ? this.users.slice() : undefined
                                };
                            };
                            return Access;
                        }());
                        /**
                         * Handles table input and output.
                         */
                        var Table = /** @class */ (function () {
                            /**
                             * Table schema.
                             *
                             * @param id {string}
                             * @param type {string} Can be undefined because tables are saved
                             *     in different dicts in template.
                             * @param cells {Array<TableCell>}
                             */
                            function Table(id, type, cells) {
                                if (!id) {
                                    throw new schema_error_1["default"].TableNameEmptyError();
                                }
                                if (!Table.rowsValid(cells)) {
                                    throw new schema_error_1["default"].TableCellFormatError(id);
                                }
                                this.id = id.toString();
                                this.type = type.toString();
                                this.cells = cells && cells.length ? cells.slice() : [];
                            }
                            Table.rowsValid = function (cells) {
                                if (!cells) {
                                    return false;
                                }
                                var result = true;
                                cells.forEach(function (c) {
                                    if (!c.rowHeader || !c.colHeader) {
                                        result = false;
                                    }
                                });
                                return result;
                            };
                            Table.prototype.getData = function () {
                                return {
                                    'id': this.id,
                                    'type': this.type,
                                    "cells": this.cells.slice()
                                };
                            };
                            return Table;
                        }());
                        var TemplateDetail = /** @class */ (function () {
                            function TemplateDetail() {
                                this.inputTables = {};
                                this.outputTables = {};
                            }
                            TemplateDetail.prototype.setInputs = function (inputKeys) {
                                this.inputKeys = inputKeys && inputKeys.length
                                    ? inputKeys.slice() : undefined;
                            };
                            TemplateDetail.prototype.setOutputs = function (outputKeys) {
                                this.outputKeys = outputKeys && outputKeys.length
                                    ? outputKeys.slice() : undefined;
                            };
                            TemplateDetail.prototype.setInputTable = function (tableId, cells) {
                                if (tableId && cells && cells.length) {
                                    this.inputTables[tableId] =
                                        new Table(tableId, 'input', cells);
                                }
                            };
                            TemplateDetail.prototype.setOutputTable = function (tableId, cells) {
                                if (tableId && cells && cells.length) {
                                    this.outputTables[tableId] =
                                        new Table(tableId, 'output', cells);
                                }
                            };
                            TemplateDetail.prototype.setCategories = function (categories) {
                                this.categories = categories && categories.length
                                    ? categories.slice() : undefined;
                            };
                            TemplateDetail.prototype.clearAllTable = function (type) {
                                if (type == 'input') {
                                    this.inputTables = {};
                                }
                                else {
                                    this.outputTables = {};
                                }
                            };
                            TemplateDetail.prototype.clearInputTable = function (tableId) {
                                if (this.inputTables[tableId]) {
                                    delete this.inputTables[tableId];
                                }
                            };
                            TemplateDetail.prototype.clearOutputTable = function (tableId) {
                                if (this.outputTables[tableId]) {
                                    delete this.outputTables[tableId];
                                }
                            };
                            TemplateDetail.prototype.isEmpty = function () {
                                var hasInput = this.inputKeys && this.inputKeys.length;
                                var hasOutput = this.outputKeys && this.outputKeys.length;
                                var hasInputTables = this.inputTables &&
                                    Object.keys(this.inputTables).length;
                                var hasOutputTables = this.outputTables &&
                                    Object.keys(this.outputTables).length;
                                var hasCategory = this.categories && this.categories.length;
                                return !(hasInput || hasOutput || hasInputTables || hasOutputTables || hasCategory);
                            };
                            /**
                             * Load template object from json object.
                             * @param data {SchemaTemplateData} Template data. Name and type are
                             *     specify in constructor instead of this function.
                             */
                            TemplateDetail.prototype.loadData = function (data) {
                                if (data.inputKeys) {
                                    this.inputKeys = data.inputKeys.slice();
                                }
                                if (data.outputKeys) {
                                    this.outputKeys = data.outputKeys.slice();
                                }
                                if (data.inputTables) {
                                    var tin = {};
                                    for (var k in data.inputTables) {
                                        if (data.inputTables.hasOwnProperty(k)) {
                                            var t = data.inputTables[k];
                                            if (k != t.id) {
                                                throw new schema_error_1["default"].TableNameMissMatchError(k, t.id);
                                            }
                                            tin[k] = new Table(t.id, t.type, t.cells);
                                        }
                                    }
                                    this.inputTables = tin;
                                }
                                else {
                                    this.inputTables = {};
                                }
                                if (data.outputTables) {
                                    var tout = {};
                                    for (var k in data.outputTables) {
                                        if (data.outputTables.hasOwnProperty(k)) {
                                            var t = data.outputTables[k];
                                            if (k != t.id) {
                                                throw new schema_error_1["default"].TableNameMissMatchError(k, t.id);
                                            }
                                            tout[k] = new Table(t.id, t.type, t.cells);
                                        }
                                    }
                                    this.outputTables = tout;
                                }
                                else {
                                    this.inputTables = {};
                                }
                                if (data.categories) {
                                    this.categories = data.categories.slice();
                                }
                            };
                            TemplateDetail.prototype.getData = function () {
                                var tin = {};
                                var tout = {};
                                // Get table data from table objects.
                                for (var k in this.inputTables) {
                                    if (this.inputTables.hasOwnProperty(k)) {
                                        tin[k] = this.inputTables[k].getData();
                                    }
                                }
                                for (var k in this.outputTables) {
                                    if (this.outputTables.hasOwnProperty(k)) {
                                        tout[k] = this.outputTables[k].getData();
                                    }
                                }
                                return {
                                    'inputKeys': this.inputKeys ? this.inputKeys.slice() : undefined,
                                    'outputKeys': this.outputKeys ? this.outputKeys.slice() : undefined,
                                    "inputTables": tin,
                                    "outputTables": tout,
                                    'categories': this.categories ? this.categories.slice() : undefined
                                };
                            };
                            return TemplateDetail;
                        }());
                        /**
                         * Keys for schema templates.
                         */
                        var Template = /** @class */ (function () {
                            function Template(templateName) {
                                if (!templateName) {
                                    throw new schema_error_1["default"].TemplateNameEmptyError();
                                }
                                this.templateName = templateName.toString();
                            }
                            Template.prototype.getTemplateDetail = function (type) {
                                if (type == 'leaf') {
                                    if (!this.leaf) {
                                        this.leaf = new TemplateDetail();
                                    }
                                    return this.leaf;
                                }
                                else if (type == 'platform') {
                                    if (!this.platform) {
                                        this.platform = new TemplateDetail();
                                    }
                                    return this.platform;
                                }
                                else {
                                    throw new schema_error_1["default"].TemplateTypeInvalidError(type);
                                }
                            };
                            Template.prototype.setInputs = function (templateType, inputKeys) {
                                this.getTemplateDetail(templateType).setInputs(inputKeys);
                            };
                            Template.prototype.setOutputs = function (templateType, outputKeys) {
                                this.getTemplateDetail(templateType).setOutputs(outputKeys);
                            };
                            Template.prototype.setInputTable = function (templateType, tableId, cells) {
                                this.getTemplateDetail(templateType).setInputTable(tableId, cells);
                            };
                            Template.prototype.setOutputTable = function (templateType, tableId, cells) {
                                this.getTemplateDetail(templateType).setOutputTable(tableId, cells);
                            };
                            Template.prototype.setCategories = function (templateType, categories) {
                                this.getTemplateDetail(templateType).setCategories(categories);
                            };
                            Template.prototype.clearAllTable = function (templateType, tableType) {
                                this.getTemplateDetail(templateType).clearAllTable(tableType);
                            };
                            Template.prototype.clearInputTable = function (templateType, tableId) {
                                this.getTemplateDetail(templateType).clearInputTable(tableId);
                            };
                            Template.prototype.clearOutputTable = function (templateType, tableId) {
                                this.getTemplateDetail(templateType).clearOutputTable(tableId);
                            };
                            Template.prototype.isEmpty = function () {
                                var leafEmpty = !this.leaf || this.leaf.isEmpty();
                                var platformEmpty = !this.platform || this.platform.isEmpty();
                                return leafEmpty && platformEmpty;
                            };
                            /**
                             * Load template object from json object.
                             * @param data {SchemaTemplateData} Template data. Name and type are
                             *     specify in constructor instead of this function.
                             */
                            Template.prototype.loadData = function (data) {
                                if (data.leaf) {
                                    this.leaf = new TemplateDetail();
                                    this.leaf.loadData(data.leaf);
                                }
                                if (data.platform) {
                                    this.platform = new TemplateDetail();
                                    this.platform.loadData(data.platform);
                                }
                            };
                            Template.prototype.getData = function () {
                                return {
                                    'templateName': this.templateName,
                                    'leaf': this.leaf ? this.leaf.getData() : undefined,
                                    'platform': this.platform ? this.platform.getData() : undefined
                                };
                            };
                            return Template;
                        }());
                        /**
                         * What kind of node this schema apply to.
                         */
                        var NodeType = /** @class */ (function () {
                            function NodeType(root, portfolio, platform, leaf) {
                                if (!(root || portfolio || platform || leaf)) {
                                    throw new schema_error_1["default"].NodeTypeAllFalseError();
                                }
                                this.root = root == true;
                                this.portfolio = portfolio == true;
                                this.platform = platform == true;
                                this.leaf = leaf == true;
                            }
                            NodeType.prototype.getData = function () {
                                return {
                                    'root': this.root,
                                    'portfolio': this.portfolio,
                                    'platform': this.platform,
                                    'leaf': this.leaf
                                };
                            };
                            return NodeType;
                        }());
                        /**
                         * If this schema applys to only specific node.
                         */
                        var SpecNode = /** @class */ (function () {
                            /**
                             *
                             * @param id {string} Tree node id.
                             * @param subtree {boolean} Apply schema to subtree (true),
                             *     or this node only.
                             */
                            function SpecNode(id, subtree) {
                                if (!id) {
                                    throw new schema_error_1["default"].SpecNodeError();
                                }
                                this.id = id.toString();
                                this.subtree = subtree == true;
                            }
                            SpecNode.prototype.getData = function () {
                                return {
                                    'id': this.id,
                                    'subtree': this.subtree
                                };
                            };
                            return SpecNode;
                        }());
                        var UniversalSchema = /** @class */ (function () {
                            /**
                             * Initialize a schema. Can be creating a new one or loading
                             * from database.
                             */
                            function UniversalSchema() {
                                this.access = new Access(true, false, false, false, undefined, undefined);
                                /**
                                 * init the dict of templates.
                                 */
                                this.templates = {};
                            }
                            UniversalSchema.prototype.getTemplate = function (templateName) {
                                if (!templateName) {
                                    return undefined;
                                }
                                if (!this.templates[templateName]) {
                                    this.templates[templateName] =
                                        new Template(templateName);
                                }
                                return this.templates[templateName];
                            };
                            UniversalSchema.prototype.checkTemplate = function (templateName) {
                                if (this.templates[templateName]) {
                                    if (this.templates[templateName].isEmpty()) {
                                        delete this.templates[templateName];
                                    }
                                }
                            };
                            UniversalSchema.prototype.getSchemaName = function () {
                                return this.id;
                            };
                            /**
                             * Get a data object for schema.
                             *
                             * @returns {SchemaData}
                             */
                            UniversalSchema.prototype.getSchemaData = function () {
                                var t = {};
                                // Get data from template objects.
                                for (var k in this.templates) {
                                    if (this.templates.hasOwnProperty(k)) {
                                        t[k] = this.templates[k].getData();
                                    }
                                }
                                return {
                                    id: this.id,
                                    access: this.access.getData(),
                                    templates: t,
                                    nodeType: this.nodeType ? this.nodeType.getData() : undefined,
                                    specNode: this.specNode ? this.specNode.getData() : undefined
                                };
                            };
                            /**
                             * Get a template data by name and leaf/platform.
                             * @param templateName {string}
                             * @param leafOrPlatform {string}
                             * @return {SchemaTemplateDetailData}
                             */
                            UniversalSchema.prototype.getTemplateData = function (templateName, leafOrPlatform) {
                                if (this.templates[templateName]) {
                                    var templateData = this.templates[templateName].getData();
                                    if (leafOrPlatform == 'leaf') {
                                        return templateData.leaf;
                                    }
                                    else if (leafOrPlatform == 'platform') {
                                        return templateData.platform;
                                    }
                                }
                                return undefined;
                            };
                            ;
                            /**
                             * Load object by data. Data should be the same format as the
                             * output of getSchemaData function.
                             *
                             * @param data {SchemaData}
                             */
                            UniversalSchema.prototype.loadData = function (data) {
                                this.id = data.id;
                                if (data.access) {
                                    this.access = new Access(data.access.portfolioAdmin, data.access.contributor, data.access.cateContributor, data.access.observer, data.access.groups, data.access.users);
                                }
                                if (data.nodeType) {
                                    this.nodeType = new NodeType(data.nodeType.root, data.nodeType.portfolio, data.nodeType.platform, data.nodeType.leaf);
                                }
                                if (data.specNode) {
                                    this.specNode = new SpecNode(data.specNode.id, data.specNode.subtree);
                                }
                                var temp = {};
                                // Get templates from data.
                                for (var k in data.templates) {
                                    if (data.templates.hasOwnProperty(k)) {
                                        if (k != data.templates[k].templateName) {
                                            throw new schema_error_1["default"].TemplateNameMissMatchError(k, data.templates[k].templateName);
                                        }
                                        var t = new Template(data.templates[k].templateName);
                                        t.loadData(data.templates[k]);
                                        if (!t.isEmpty()) {
                                            temp[k] = t;
                                        }
                                    }
                                }
                                this.templates = temp;
                            };
                            /**
                             * Set id (name) of this schema.
                             *
                             * @param id {string}
                             */
                            UniversalSchema.prototype.setId = function (id) {
                                if (id) {
                                    this.id = id.toString();
                                }
                                return this;
                            };
                            /**
                             * Set who can access this schema. This part of project is not
                             * checking if groups or users existing.
                             *
                             * @param portfolioAdmin {boolean} Portfolio admins should
                             *     always set to true.
                             * @param contributor {boolean}
                             * @param observer {boolean}
                             * @param groups {Array<string>} List of group ids. User in
                             *     these groups can see the schema.
                             * @param users {Array<string>} List of user ids. These users
                             *     can see the schema.
                             *
                             * @return This object for method chaining.
                             */
                            UniversalSchema.prototype.setAccess = function (portfolioAdmin, contributor, cateContributor, observer, groups, users) {
                                // Portfolio admins always have access.
                                portfolioAdmin = true;
                                this.access = new Access(portfolioAdmin, contributor, cateContributor, observer, groups, users);
                                return this;
                            };
                            /**
                             * Set input and output for template. Input and output have
                             * the same data structure.
                             *
                             * @param templateName {string}
                             * @param templateType {string} 'leaf' or 'platform'.
                             * @param type {string} Can be 'input' or 'output'.
                             * @param keys {Array<string>}
                             */
                            UniversalSchema.prototype.setTemplateIO = function (templateName, templateType, type, keys) {
                                var t = this.getTemplate(templateName);
                                if (t) {
                                    if (type === 'input') {
                                        t.setInputs(templateType, keys);
                                    }
                                    else {
                                        t.setOutputs(templateType, keys);
                                    }
                                    this.checkTemplate(templateName);
                                }
                            };
                            /**
                             * Handle table input and output together because they have
                             * same structure.
                             *
                             * @param templateName {string}
                             * @param templateType {string} 'leaf' or 'platform'.
                             * @param type {string} Can be 'input' or 'output'.
                             * @param tableId {string}
                             * @param cells {Array<TableCell>} Coordinate of cells.
                             *     First num is row index, second one is col index.
                             *     Example: [[row, col], [0, 0], [1, 2]]
                             */
                            UniversalSchema.prototype.setTemplateTableIO = function (templateName, templateType, type, tableId, cells) {
                                var t = this.getTemplate(templateName);
                                if (t) {
                                    if (type === 'input') {
                                        t.setInputTable(templateType, tableId, cells);
                                    }
                                    else {
                                        t.setOutputTable(templateType, tableId, cells);
                                    }
                                    this.checkTemplate(templateName);
                                }
                            };
                            /**
                             * Set a schema config for a specific template. This function
                             * is to set input fields.
                             *
                             * @param templateName {string}
                             * @param templateType {string} 'leaf' or 'platform'.
                             * @param inputKeys {Array<string>}
                             */
                            UniversalSchema.prototype.setTemplateInputs = function (templateName, templateType, inputKeys) {
                                this.setTemplateIO(templateName, templateType, 'input', inputKeys);
                                return this;
                            };
                            /**
                             * Set a schema config for a specific template. This function
                             * is to set output fields.
                             *
                             * @param templateName {string}
                             * @param templateType {string} 'leaf' or 'platform'.
                             * @param outputKeys {Array<string>}
                             */
                            UniversalSchema.prototype.setTemplateOutputs = function (templateName, templateType, outputKeys) {
                                this.setTemplateIO(templateName, templateType, 'output', outputKeys);
                                return this;
                            };
                            /**
                             * Set a schema config for a specific template. This function
                             * is to set table inputs.
                             *
                             * @param templateName {string}
                             * @param templateType {string} 'leaf' or 'platform'.
                             * @param tableId {string}
                             * @param cells {Array<TableCell>} Coordinate of cells.
                             *     First num is row index, second one is col index.
                             *     Example: [[row, col], [0, 0], [1, 2]]
                             */
                            UniversalSchema.prototype.setTemplateInputTable = function (templateName, templateType, tableId, cells) {
                                this.setTemplateTableIO(templateName, templateType, 'input', tableId, cells);
                                return this;
                            };
                            /**
                             * Set a schema config for a specific template. This function
                             * is to set table outputs.
                             *
                             * @param templateName {string}
                             * @param templateType {string} 'leaf' or 'platform'.
                             * @param tableId {string}
                             * @param cells {Array<TableCell>} Coordinate of cells.
                             *     First num is row index, second one is col index.
                             *     Example: [[row, col], [0, 0], [1, 2]]
                             */
                            UniversalSchema.prototype.setTemplateOutputTable = function (templateName, templateType, tableId, cells) {
                                this.setTemplateTableIO(templateName, templateType, 'output', tableId, cells);
                                return this;
                            };
                            /**
                             * Set a schema config for a specific template. This function
                             * is to set categories fields.
                             *
                             * @param templateName {string}
                             * @param templateType {string} 'leaf' or 'platform'.
                             * @param categories {Array<string>}
                             */
                            UniversalSchema.prototype.setTemplateCategories = function (templateName, templateType, categories) {
                                var t = this.getTemplate(templateName);
                                if (t) {
                                    t.setCategories(templateType, categories);
                                    this.checkTemplate(templateName);
                                }
                                return this;
                            };
                            /**
                             * Clear all table from template by type.
                             *
                             * @param templateName {string}
                             * @param templateType {string} 'leaf' or 'platform'.
                             * @param tableType {string} Can be input or output.
                             */
                            UniversalSchema.prototype.clearAllTables = function (templateName, templateType, tableType) {
                                var t = this.getTemplate(templateName);
                                if (t) {
                                    t.clearAllTable(templateType, tableType);
                                }
                                return this;
                            };
                            /**
                             * Remove a table input for a schema. If template or table name
                             * does not exist, do nothing.
                             *
                             * @param templateName {string}
                             * @param templateType {string} 'leaf' or 'platform'.
                             * @param tableId {string}
                             */
                            UniversalSchema.prototype.clearTemplateInputTable = function (templateName, templateType, tableId) {
                                var t = this.getTemplate(templateName);
                                if (t) {
                                    t.clearInputTable(templateType, tableId);
                                    this.checkTemplate(templateName);
                                }
                                return this;
                            };
                            /**
                             * Remove a table output for a schema. If template or table name
                             * does not exist, do nothing.
                             *
                             * @param templateName {string}
                             * @param templateType {string} 'leaf' or 'platform'.
                             * @param tableId {string}
                             */
                            UniversalSchema.prototype.clearTemplateOutputTable = function (templateName, templateType, tableId) {
                                var t = this.getTemplate(templateName);
                                if (t) {
                                    t.clearOutputTable(templateType, tableId);
                                    this.checkTemplate(templateName);
                                }
                                return this;
                            };
                            /**
                             * What kind of node this schema apply to.
                             *
                             * Default is undefined, means no restriction. If all params
                             * are true, the node type will be set to undefined.
                             *
                             * At least one of the options should be true, otherwise it
                             * will be set to root node by default. However, in this case,
                             * the table may not display properly.
                             *
                             * @param root {boolean}
                             * @param portfolio {boolean}
                             * @param platform {boolean}
                             * @param leaf {boolean}
                             */
                            UniversalSchema.prototype.setNodeType = function (root, portfolio, platform, leaf) {
                                if (!(root && portfolio && platform && leaf)) {
                                    this.nodeType = new NodeType(root, portfolio, platform, leaf);
                                }
                                return this;
                            };
                            /**
                             * Schema apply to specific node. If schema is applyed to one
                             * specific node, it should be saved under the node instead of
                             * root node.
                             *
                             * @param nodeId {string} Tree node id. Set to undefined means
                             *     no restriction.
                             * @param subtree {boolean} Apply schema to subtree (true),
                             *     or this node only (false).
                             */
                            UniversalSchema.prototype.setSpecNode = function (nodeId, subtree) {
                                if (nodeId) {
                                    this.specNode = new SpecNode(nodeId, subtree);
                                }
                                else {
                                    this.specNode = undefined;
                                }
                                return this;
                            };
                            return UniversalSchema;
                        }());
                        logic.UniversalSchema = UniversalSchema;
                    })(logic = schema.logic || (schema.logic = {}));
                })(schema = universal.schema || (universal.schema = {}));
            })(universal = acts.universal || (acts.universal = {}));
        })(acts = r6.acts || (r6.acts = {}));
    })(r6 = smartorg.r6 || (smartorg.r6 = {}));
})(smartorg || (smartorg = {}));
exports["default"] = smartorg.r6.acts.universal.schema.logic;
//# sourceMappingURL=schema.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/universal-io/app/schema-builder/app/js/logic/schema.js